import {Component, inject, Input, OnDestroy, OnInit} from '@angular/core';

import {NgbModalRef} from "@ng-bootstrap/ng-bootstrap";

import {ModalService} from "@numizmat/services/common";
import {CurrentUser} from "@numizmat/services-models/account";
import {CurrentUserStateService} from "@numizmat/services/account";
import {OwnProfileResponse} from "@numizmat/services-models/core";
import {
  PasswordModalComponent
} from "@numizmat/pages/profile-page/components/own-profile/modals/password-modal/password-modal.component";
import {
  EmailModalComponent
} from "@numizmat/pages/profile-page/components/own-profile/modals/email-modal/email-modal.component";
import {Subscription} from "rxjs";
import {
  UserDefaultAddressModalComponent
} from "@numizmat/pages/profile-page/components/own-profile/modals/user-default-address-modal/user-default-address-modal.component";
import {
  UserConfirmationMethodModalComponent
} from "@numizmat/pages/profile-page/components/own-profile/modals/user-confirmation-method-modal/user-confirmation-method-modal.component";

@Component({
  selector: 'nz-account-settings',
  standalone: true,
  imports: [],
  templateUrl: './account-settings.component.html',
  styleUrl: './account-settings.component.scss'
})
export class AccountSettingsComponent implements OnInit, OnDestroy {
  @Input() profile!: OwnProfileResponse;

  private modalService: ModalService = inject(ModalService);
  private currentUserStateService: CurrentUserStateService = inject(CurrentUserStateService);

  protected currentUser?: CurrentUser;

  private subs: Subscription = new Subscription();

  public ngOnInit(): void {
    this.getCurrentUser();
  }

  public ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  protected onOpenPasswordModal(): void {
    this.modalService.open(PasswordModalComponent, {
      scrollable: true
    });
  }

  protected onOpenEmailModal(): void {
    const modalRef: NgbModalRef = this.modalService.open(EmailModalComponent, {
      scrollable: true
    });
    modalRef.componentInstance.currentEmail = this.profile.userEmail;
    const subscription: Subscription = modalRef.componentInstance.emailChange.subscribe({
      next: (newEmail: string) => {
        this.profile.userEmail = newEmail;
      }
    });
    this.subs.add(subscription);
  }

  protected onOpenUserDefaultAddressModal(): void {
    const modalRef: NgbModalRef = this.modalService.open(UserDefaultAddressModalComponent, {
      scrollable: false
    });
    modalRef.componentInstance.currentRegionId = this.profile.regionId;
    modalRef.componentInstance.currentMunicipalityId = this.profile.municipalityId;
    modalRef.componentInstance.currentPopulatedPlaceId = this.profile.populatedPlaceId;

    const subscription: Subscription = modalRef.componentInstance.addressChange.subscribe({
      next: (newAddress: any) => {
        this.profile.regionId = newAddress.regionId;
        this.profile.municipalityId = newAddress.municipalityId;
        this.profile.populatedPlaceId = newAddress.populatedPlaceId;
        this.profile.populatedPlaceName = newAddress.populatedPlaceName;
      }
    });
    this.subs.add(subscription);
  }

  protected onOpenUserConfirmationMethodModal(): void {
    const modalRef: NgbModalRef = this.modalService.open(UserConfirmationMethodModalComponent, {
      scrollable: true
    });
  }

  private getCurrentUser(): void {
    const subscription: Subscription = this.currentUserStateService.getCurrentUser().subscribe({
      next: currentUser => {
        this.currentUser = currentUser;
      }
    });
    this.subs.add(subscription);
  }
}
